// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatWrapper__HX_cO {
  width: 500px;
  height: calc(100% - 105px);
  row-gap: 25px;
  display: flex;
  flex-direction: column;
  background-color: var(--tables-primary-row-surface-default);
  position: fixed;
  right: 25px;
  bottom: 25px;
  border-radius: 4px;
  box-shadow: 0px 60px 17px 0px rgba(163, 163, 163, 0), 0px 38px 15px 0px rgba(163, 163, 163, 0.02), 0px 21px 13px 0px rgba(163, 163, 163, 0.06), 0px 10px 10px 0px rgba(163, 163, 163, 0.1), 0px 2px 5px 0px rgba(163, 163, 163, 0.12);
  z-index: 2;
}
@media (max-width: 900px) {
  .chatWrapper__HX_cO {
    width: 450px;
    height: 450px;
    right: 15px;
    bottom: 15px;
    row-gap: 15px;
  }
}

.confirmModalWrapper__ubEh2::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
}

.chatHead__W1xh0 {
  min-height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  position: relative;
}
.chatHead__W1xh0::before {
  content: "";
  width: 100%;
  height: 1px;
  background-color: var(--tables-primary-row-stroke);
  position: absolute;
  bottom: -0.5px;
  left: 0;
}
.chatHead__W1xh0::after {
  content: "";
  width: 42px;
  height: 3px;
  background-color: var(--brand-logo-surface);
  position: absolute;
  bottom: -1.5px;
  left: 0;
  z-index: 3;
}

.chatTitle__ZUzkH {
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--header-title-main);
}

.chatHeadActions__g0LaP {
  display: flex;
  align-items: center;
  column-gap: 20px;
}

.createChatIcon__FfWp_ {
  cursor: pointer;
}
.createChatIcon__FfWp_:focus {
  outline: none;
}
.createChatIcon__FfWp_ path {
  stroke: var(--buttons-surface);
}

.closeIcon__ezOSD {
  cursor: pointer;
}

.chatBody__csXtg {
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding-left: 25px;
  padding-right: 25px;
  overflow-y: auto;
}
.chatBody__csXtg::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.chatBody__csXtg::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.chatBody__csXtg::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.chatBody__csXtg::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.chatFooter__Mg9L2 {
  position: relative;
  padding: 0 25px 25px;
}

.expiredMessage__l9iKy {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--tables-primary-row-text-main);
  padding: 15px;
  border-radius: 2px;
  background-color: var(--tabs-surface-default);
}

.newSessionBtn___jDwV {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  color: var(--buttons-surface);
  text-transform: uppercase;
  cursor: pointer;
}

.fieldWrapper__D2Eog {
  width: 100%;
}
.fieldWrapper__D2Eog .editorWrapper__MvI8E .tox-edit-area__iframe__PQ1jw {
  border: 1px solid var(--Inputs-default-stroke) !important;
  background: var(--Inputs-default-surface-default) !important;
}

.commentSendBlock__dtKoU {
  position: absolute;
  top: 5px;
  right: 15px;
  width: 20px;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/ChatComponent/components/ChatWindow/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,0BAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,2DAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qOACE;EAKF,UAAA;AA9EF;AAgFE;EAnBF;IAoBI,YAAA;IACA,aAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;EA7EF;AACF;;AAiFE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,oCAAA;AA9EJ;;AAkFA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA/EF;AAiFE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,kDAAA;EACA,kBAAA;EACA,cAAA;EACA,OAAA;AA/EJ;AAkFE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,2CAAA;EACA,kBAAA;EACA,cAAA;EACA,OAAA;EACA,UAAA;AAhFJ;;AAoFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;AAjFF;;AAoFA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAjFF;;AAoFA;EACE,eAAA;AAjFF;AAmFE;EACE,aAAA;AAjFJ;AAoFE;EACE,8BAAA;AAlFJ;;AAsFA;EACE,eAAA;AAnFF;;AAsFA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAnFF;AAxEE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA0EJ;AAvEE;EACE,+BAAA;EACA,kBAAA;AAyEJ;AAtEE;EACE,8BAAA;EACA,kBAAA;AAwEJ;AArEE;EACE,gBAAA;EACA,kBAAA;AAuEJ;;AAuEA;EACE,kBAAA;EACA,oBAAA;AApEF;;AAuEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,6CAAA;AApEF;;AAuEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;AApEF;;AAuEA;EACE,WAAA;AApEF;AAsEE;EACE,yDAAA;EACA,4DAAA;AApEJ;;AAwEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AArEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.chatWrapper {\n  width: 500px;\n  height: calc(100% - 105px);\n  row-gap: 25px;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--tables-primary-row-surface-default);\n  position: fixed;\n  right: 25px;\n  bottom: 25px;\n  border-radius: 4px;\n  box-shadow:\n    0px 60px 17px 0px rgba(163, 163, 163, 0),\n    0px 38px 15px 0px rgba(163, 163, 163, 0.02),\n    0px 21px 13px 0px rgba(163, 163, 163, 0.06),\n    0px 10px 10px 0px rgba(163, 163, 163, 0.1),\n    0px 2px 5px 0px rgba(163, 163, 163, 0.12);\n  z-index: 2;\n\n  @media (max-width: 900px) {\n    width: 450px;\n    height: 450px;\n    right: 15px;\n    bottom: 15px;\n    row-gap: 15px;\n  }\n}\n\n.confirmModalWrapper {\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n}\n\n.chatHead {\n  min-height: 60px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 25px;\n  position: relative;\n\n  &::before {\n    content: '';\n    width: 100%;\n    height: 1px;\n    background-color: var(--tables-primary-row-stroke);\n    position: absolute;\n    bottom: -0.5px;\n    left: 0;\n  }\n\n  &::after {\n    content: '';\n    width: 42px;\n    height: 3px;\n    background-color: var(--brand-logo-surface);\n    position: absolute;\n    bottom: -1.5px;\n    left: 0;\n    z-index: 3;\n  }\n}\n\n.chatTitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--header-title-main);\n}\n\n.chatHeadActions {\n  display: flex;\n  align-items: center;\n  column-gap: 20px;\n}\n\n.createChatIcon {\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n\n  path {\n    stroke: var(--buttons-surface);\n  }\n}\n\n.closeIcon {\n  cursor: pointer;\n}\n\n.chatBody {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n  padding-left: 25px;\n  padding-right: 25px;\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.chatFooter {\n  position: relative;\n  padding: 0 25px 25px;\n}\n\n.expiredMessage {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-main);\n  padding: 15px;\n  border-radius: 2px;\n  background-color: var(--tabs-surface-default);\n}\n\n.newSessionBtn {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  color: var(--buttons-surface);\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.fieldWrapper {\n  width: 100%;\n\n  .editorWrapper .tox-edit-area__iframe {\n    border: 1px solid var(--Inputs-default-stroke) !important;\n    background: var(--Inputs-default-surface-default) !important;\n  }\n}\n\n.commentSendBlock {\n  position: absolute;\n  top: 5px;\n  right: 15px;\n  width: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatWrapper": `chatWrapper__HX_cO`,
	"confirmModalWrapper": `confirmModalWrapper__ubEh2`,
	"chatHead": `chatHead__W1xh0`,
	"chatTitle": `chatTitle__ZUzkH`,
	"chatHeadActions": `chatHeadActions__g0LaP`,
	"createChatIcon": `createChatIcon__FfWp_`,
	"closeIcon": `closeIcon__ezOSD`,
	"chatBody": `chatBody__csXtg`,
	"chatFooter": `chatFooter__Mg9L2`,
	"expiredMessage": `expiredMessage__l9iKy`,
	"newSessionBtn": `newSessionBtn___jDwV`,
	"fieldWrapper": `fieldWrapper__D2Eog`,
	"editorWrapper": `editorWrapper__MvI8E`,
	"toxEditAreaIframe": `tox-edit-area__iframe__PQ1jw`,
	"commentSendBlock": `commentSendBlock__dtKoU`
};
module.exports = ___CSS_LOADER_EXPORT___;
